import { Locale } from "../Locale.ts";

/**
 * UI strings for `SiteFooter.tsx` — ADR 0051 part 2.
 *
 * The footer mostly renders `routeSeo.json` data (group headings, page
 * titles) via `FOOTER_GROUPS`/`routesInGroup` - untouched here, same
 * reasoning as `nav.ts`. Only the labelling chrome and the closing tagline
 * are genuine interface strings.
 */
const en = {
    "footer.moreFromThisSiteAria": "More from this site",
    "footer.aboutThisSiteAria": "About this site",
    "footer.tagline": " — free printable math worksheets and charts.",
} as const;

export type FooterStringKey = keyof typeof en;

const es = {
    "footer.moreFromThisSiteAria": "Más de este sitio",
    "footer.aboutThisSiteAria": "Sobre este sitio",
    "footer.tagline": " — hojas de ejercicios y tablas de matemáticas gratis para imprimir.",
} satisfies Record<FooterStringKey, string>;

const fr = {
    "footer.moreFromThisSiteAria": "Plus sur ce site",
    "footer.aboutThisSiteAria": "À propos de ce site",
    "footer.tagline": " — fiches et tables de mathématiques gratuites à imprimer.",
} satisfies Record<FooterStringKey, string>;

export const footerStrings: Record<Locale, Record<FooterStringKey, string>> = { en, es, fr };
